export default (node) => {
  const allTitles = node.querySelectorAll('[data-faq-title]');

  const renderTitles = () => {
    const titlesContainer = node.querySelector('[data-faq-titles]');
    allTitles.forEach((title, index) => {
      const liElement = document.createElement('li');
      liElement.classList.add(
        'py-2',
        'px-3',
        'text-sm-medium',
        'cursor-pointer',
        'w-max'
      );
      liElement.innerText = title.innerText;
      liElement.setAttribute(
        'data-faq-title-slug',
        title.getAttribute('data-faq-title')
      );
      if (index === 0) {
        liElement.classList.add('bg-white');
      }
      titlesContainer.appendChild(liElement);
    });
  };

  const addTitlesListener = () => {
    const allMainTitles = node.querySelectorAll('[data-faq-titles] > li');
    const allGroups = node.querySelectorAll('[data-faq-group]');

    allMainTitles.forEach((title) => {
      title.addEventListener('click', (e) => {
        const slug = e.currentTarget.getAttribute('data-faq-title-slug');

        // Hide all FAQ groups
        allGroups.forEach((group) => {
          group.classList.add('hidden');
        });

        // Show only the matching FAQ group
        const targetGroup = node.querySelector(`[data-faq-group="${slug}"]`);
        if (targetGroup) {
          targetGroup.classList.remove('hidden');

          // Optionally scroll to the revealed group
          window.scrollTo({
            top: targetGroup.offsetTop - 130,
            behavior: 'smooth',
          });
        }

        // Toggle active tab styling
        allMainTitles.forEach((el) => {
          el.classList.remove('bg-white');
        });
        e.currentTarget.classList.add('bg-white');
      });
    });
  };

  const init = () => {
    renderTitles();
    addTitlesListener();

    // ✅ Show the first group by default
    const allGroups = node.querySelectorAll('[data-faq-group]');
    if (allGroups.length > 0) {
      allGroups.forEach((group, index) => {
        group.classList.toggle('hidden', index !== 0);
      });
    }
  };
  init();
};
